import React, {useEffect, useState} from "react";
import {Flex, Grid, View} from "@aws-amplify/ui-react";
import {Outlet, useLoaderData, useLocation, matchPath, Await} from "react-router-dom";
import styles from './index.module.css';
import {parseHtmlString, getTitleColor} from "../../utils";
import ItemsCollection from "../../components/ItemsCollection";
import Loading from "../../components/Loading";
import ErrorBoundary from "../../components/ErrorBoundary";
import LicenseWarning from "../../components/LicenseWarning";

const Course = () => {
  const [missingLicense, setMissingLicense] = useState(false);

  const {
    courseId,
    course: loadingCourse = {},
  } = useLoaderData();

  const location = useLocation();
  const {pathname = ""} = location || {};
  const matchCourse = matchPath("/corsi/:courseId", pathname);
  const matchLesson = matchPath("/corsi/:courseId/lezioni/:lessonId", pathname);
  const matchTopic = matchPath("/corsi/:courseId/lezioni/:lessonId/approfondimenti/:topicId", pathname);

  const scrolledRef = React.useRef(false);

  useEffect(() => {
    if (window.sessionStorage.getItem("missing_license")) {
      setMissingLicense(true);
    } else {
      setMissingLicense(false);
    }

    if (!!matchCourse && !matchLesson && !matchTopic) {
      setTimeout(() => {
        const element = document.getElementById("course");
        if (element) {
          element.scrollIntoView({block: "start", inline: "nearest", behavior: 'smooth'});
          scrolledRef.current = true;
        }
      }, 100);
    }
  }, [courseId]);

  const titleClassNames = [styles.courseTitle, getTitleColor(courseId)]

  return (
    <View
      className={
        courseId === 3201 ?
          styles.kids :
          ''
      }
    >
      <Grid
        id="course"
        templateColumns="1fr"
        templateRows="30vh repeat(3, auto)"
      >
        <React.Suspense
          fallback={<Loading />}
        >
          <Await
            resolve={loadingCourse}
            errorElement={
              <ErrorBoundary />
            }
          >
            {(course) => {
              const {
                description = "",
                cover = "",
                title = "",
                lessons = [],
              } = course || {};

              return (
                <>
                  <View
                    position="relative"
                    backgroundImage={`url(${cover})`}
                    className={styles.courseHeadingWrapper}
                  >
                    <h1 className={titleClassNames.join(' ')}>
                      {title}
                    </h1>
                  </View>

                  <Flex
                    wrap="wrap"
                    direction="column"
                    alignItems="center"
                    alignContent="center"
                    justifyContent="start"
                    className={styles.courseContentWrapper}
                  >
                    {parseHtmlString(description)}
                    {
                      missingLicense &&
                      <LicenseWarning isInCourse/>
                    }
                  </Flex>

                  {
                    !!matchCourse &&
                    <View className={styles.courseItemsCollectionWrapper}>
                      <ItemsCollection
                        items={lessons}
                        courseId={courseId}
                        backgroundColor="detail"
                      />
                    </View>
                  }

                  <View>
                    <Outlet context={{course}}/>
                  </View>
                </>
              )
            }}
          </Await>
        </React.Suspense>
      </Grid>
    </View>
  )
}

export default Course